import React from 'react'

export default function Footer() {
  return (
    <div className='Footer'>
        <p>© 2025 Koval Scapes, LLC</p>
        <p>contact@kovalscapes.com</p>
        <p>330 987 6543</p>
    </div>
  )
}
